export default function extractUrlFromString(inputString?: string): string {
  if (!inputString) return '';
  const urlRegex = /(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+(?:\/[^\s"]*)?/;
  const match = inputString.match(urlRegex);
  return match ? match[0].replace(/["'<>]/g, '') : '';
}
